import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=5f155981&scoped=true"
import script from "./ReportsPage.vue?vue&type=script&lang=ts"
export * from "./ReportsPage.vue?vue&type=script&lang=ts"
import style0 from "./ReportsPage.vue?vue&type=style&index=0&id=5f155981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f155981",
  null
  
)

export default component.exports